@let loggedOutIn = logoutCountdown();

@if (loggedOutIn) {
  <span
    class="text-sm font-normal"
    data-translation="countdown.login-expiration"
    [translate]="'countdown.login-expiration'"
    [translateParams]="{ logoutCountdown: loggedOutIn }"
  ></span>
}

@if (nextExpiringVoucher && nextExpiringVoucher.code) {
  <span
    class="text-sm font-normal"
    data-translation="countdown.voucher-expiration"
    [translate]="'countdown.voucher-expiration'"
    [translateParams]="{ voucherCode: nextExpiringVoucher.code, expiringCountdown: nextExpiringVoucher.showTime }"
  ></span>
}

@if (timeToReleaseTicket) {
  <span
    class="text-sm font-normal"
    data-translation="countdown.ticket-expiration"
    [translate]="'countdown.ticket-expiration'"
    [translateParams]="{ ticketExpiringCountdown: timeToReleaseTicket }"
  ></span>
}

<ls-modal
  data-nested-translation="ticket.timeout.modalWindow.title"
  [title]="'ticket.timeout.modalWindow.title' | translate | hideTranslation"
  [visible]="ticketBookingTimeoutModalOpen"
  [closable]="false"
  [footerContent]="false"
>
  <div class="flex flex-wrap justify-content-center gap-1">
    <ls-button
      data-nested-translation="ticket.timeout.modalWindow.close"
      [styleClass]="'button-secondary'"
      [color]="'secondary'"
      [size]="'md'"
      [label]="'ticket.timeout.modalWindow.close' | translate | hideTranslation"
      (onClick)="closeModalWindow($event)"
    />
  </div>
</ls-modal>
